module.exports = web3dPluginMateria;